<ng-template #templateModal>
  <div class="modal-container" [ngClass]="modalSettings.class">
    <div class="modal-header">
      <div class="modal-title pull-left">{{ title }}</div>
      <button
        *ngIf="!modalSettings.disableCloseButton"
        type="button"
        class="close pull-right"
        aria-label="Close"
        (click)="closeModal()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body {{ modalSettings.bodyClass }}">
      {{ text }}
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
    <div *ngIf="!skipFooter" class="modal-footer">
      <ng-container *ngFor="let button of buttons">
        <button
          *ngIf="button.openModal === undefined"
          type="button"
          (click)="buttonClicked(button)"
          class="{{ button.class }}"
          [disabled]="button.disabled"
        >
          {{ button.label }}
        </button>
        <button
          *ngIf="button.openModal !== undefined"
          type="button"
          class="{{ button.class }}"
        >
          {{ button.label }}
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>
